import { render, staticRenderFns } from "./KundeWohnungen.vue?vue&type=template&id=30e2ccb9&"
import script from "./KundeWohnungen.vue?vue&type=script&lang=js&"
export * from "./KundeWohnungen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports